// AUTO-GENERATED SQL Builder (V40 Final) for BookingPartnerChange
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingPartnerChangeSql {
  private ast = new SqlAst('BookingPartnerChange', 'bookingPartnerChange');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public bookingPackageId: SqlField;
  public changeType: SqlField;
  public status: SqlField;
  public fromName: SqlField;
  public fromVendorId: SqlField;
  public toName: SqlField;
  public toVendorId: SqlField;
  public amount: SqlField;
  public newAmount: SqlField;
  public listPrice: SqlField;
  public changedDate: SqlField;
  public serviceName: SqlField;
  public consent: SqlField;
  public creditAmount: SqlField;
  public toOfferingId: SqlField;
  public isInhouse: SqlField;
  public booking: SqlNavHybrid;
  public bookingPackage: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public fromVendor: SqlNavHybrid;
  public toOffering: SqlNavHybrid;
  public toVendor: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingPartnerChange', 'guid', '', 'id', 'bookingPartnerChange_guid');
    this.bookingId = new SqlField('bookingPartnerChange', 'bookingId', 'booking', 'id', 'bookingPartnerChange_booking');
    this.bookingPackageId = new SqlField('bookingPartnerChange', 'bookingPackageId', 'bookingPackage', 'id', 'bookingPartnerChange_bookingPackage');
    this.changeType = new SqlField('bookingPartnerChange', 'changeType', '', 'id', 'bookingPartnerChange_changeType');
    this.status = new SqlField('bookingPartnerChange', 'status', '', 'id', 'bookingPartnerChange_status');
    this.fromName = new SqlField('bookingPartnerChange', 'fromName', '', 'id', 'bookingPartnerChange_fromName');
    this.fromVendorId = new SqlField('bookingPartnerChange', 'fromVendorId', '', 'id', 'bookingPartnerChange_fromVendor');
    this.toName = new SqlField('bookingPartnerChange', 'toName', '', 'id', 'bookingPartnerChange_toName');
    this.toVendorId = new SqlField('bookingPartnerChange', 'toVendorId', '', 'id', 'bookingPartnerChange_toVendor');
    this.amount = new SqlField('bookingPartnerChange', 'amount', '', 'id', 'bookingPartnerChange_amount');
    this.newAmount = new SqlField('bookingPartnerChange', 'newAmount', '', 'id', 'bookingPartnerChange_newAmount');
    this.listPrice = new SqlField('bookingPartnerChange', 'listPrice', '', 'id', 'bookingPartnerChange_listPrice');
    this.changedDate = new SqlField('bookingPartnerChange', 'changedDate', '', 'id', 'bookingPartnerChange_changedDate');
    this.serviceName = new SqlField('bookingPartnerChange', 'serviceName', '', 'id', 'bookingPartnerChange_serviceName');
    this.consent = new SqlField('bookingPartnerChange', 'consent', '', 'id', 'bookingPartnerChange_consent');
    this.creditAmount = new SqlField('bookingPartnerChange', 'creditAmount', '', 'id', 'bookingPartnerChange_creditAmount');
    this.toOfferingId = new SqlField('bookingPartnerChange', 'toOfferingId', '', 'id', 'bookingPartnerChange_toOffering');
    this.isInhouse = new SqlField('bookingPartnerChange', 'isInhouse', '', 'id', 'bookingPartnerChange_isInhouse');
    this.booking = createNavHybrid('bookingPartnerChange', 'bookingPartnerChange_booking', 'Booking');
    this.bookingPackage = createNavHybrid('bookingPartnerChange', 'bookingPartnerChange_bookingPackage', 'BookingPackage');
    this.createdByUser = createNavHybrid('bookingPartnerChange', 'bookingPartnerChange_createdByUser', 'User');
    this.fromVendor = createNavHybrid('bookingPartnerChange', 'bookingPartnerChange_fromVendor', 'Vendor');
    this.toOffering = createNavHybrid('bookingPartnerChange', 'bookingPartnerChange_toOffering', 'Offering');
    this.toVendor = createNavHybrid('bookingPartnerChange', 'bookingPartnerChange_toVendor', 'Vendor');
    this.updatedByUser = createNavHybrid('bookingPartnerChange', 'bookingPartnerChange_updatedByUser', 'User');
    this.id = new SqlField('bookingPartnerChange', 'id', '', 'id', 'bookingPartnerChange_id');
    this.isDeleted = new SqlField('bookingPartnerChange', 'isDeleted', '', 'id', 'bookingPartnerChange_isDeleted');
    this.createdBy = new SqlField('bookingPartnerChange', 'createdBy', '', 'id', 'bookingPartnerChange_createdBy');
    this.createdDate = new SqlField('bookingPartnerChange', 'createdDate', '', 'id', 'bookingPartnerChange_createdDate');
    this.updatedBy = new SqlField('bookingPartnerChange', 'updatedBy', '', 'id', 'bookingPartnerChange_updatedBy');
    this.updatedDate = new SqlField('bookingPartnerChange', 'updatedDate', '', 'id', 'bookingPartnerChange_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingPartnerChangeSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingPartnerChangeSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingPartnerChangeSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingPartnerChangeSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingPartnerChangeSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingPartnerChangeSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingPartnerChangeSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingPartnerChangeSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingPartnerChangeSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingPartnerChangeSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
